<template>
  <div class="w-full h-full">
    <div v-if="loader == true" class="w-full h-full"></div>
    <form
      v-else
      @submit.prevent="submitEducation"
      @click.stop
      class="w-full h-auto bg-white p-5"
    >
      <div class="flex justify-between items-center py-4">
        <h2 class="text-xl font-semibold text-heading">
          Education Work Experience
        </h2>
        <div>
          <button
            v-if="submitAdditional == true"
            @click="toggleEdit"
            type="button"
            class="px-5 py-1 btn text-[16px] rounded-md"
          >
            Edit
          </button>
          <button
            v-if="toggle_edit == true"
            @click="
              disableStatus = true;
              submitAdditional = true;
              toggle_edit = false;
            "
            type="button"
            class="px-5 py-1 btn text-[16px] rounded-md"
          >
            Close
          </button>
        </div>
      </div>
      <!--10th sslc details start  -->
      <div class="flex flex-col gap-5">
        <h1 class="text font-bold bg-primary text-center text-lg">
          10th / SSC Details
        </h1>
        <div>
          <p class="text-sm text-[#4b5563] py-2 font-medium">
            Class 10 / Equivalent
          </p>
          <div class="overflow-x-auto">
            <table class="w-full text-black">
              <thead>
                <tr class="text-sm">
                  <th class="border table_border p-2 w-5"></th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="schoolname" class="text-sm input_label"
                      >School Name <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="board" class="text-sm input_label"
                      >Board <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="yearofpass" class="text-sm input_label"
                      >Year of Passing <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="makingscheme" class="text-sm input_label"
                      >Making Scheme<span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[200px]">
                    <label for="aggregatepercentage" class="text-sm input_label"
                      >Aggregate Percentage/CGPA Obtained
                      <span class="span-color">*</span></label
                    >
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-sm">
                  <td class="border table_border p-1">
                    <p class="text-sm text-[#4b5563] font-normal text-center">
                      10th
                    </p>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="text"
                      class="w-full px-3 py-2 text-sm rounded-md font-normal text-input"
                      v-model="tenth_schoolname"
                      placeholder="SSLC school name"
                      required
                    />
                  </td>
                  <td class="border table_border p-1">
                    <select
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      class="block w-full py-2 text-sm font-normal text-input rounded-md"
                      aria-label="Default select example"
                      required
                      v-model="tenth_board"
                    >
                      <option value="" selected disabled>Select</option>
                      <option
                        v-for="board in tenth_board_list"
                        :key="board.id"
                        :value="board.id"
                      >
                        {{ board.name }}
                      </option>
                    </select>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="date"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md text-input"
                      v-model="tenth_yearofpass"
                      required
                    />
                  </td>
                  <td class="border table_border p-1">
                    <select
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      class="block w-full py-2 text-sm font-normal rounded-md text-input"
                      aria-label="Default select example"
                      required
                      v-model="tenth_makingscheme"
                    >
                      <option value="" selected disabled>Select</option>
                      <option
                        v-for="schemes in tenth_scheme_list"
                        :key="schemes.id"
                        :value="schemes.id"
                      >
                        {{ schemes.name }}
                      </option>
                    </select>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="tel"
                      onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                      maxlength="2"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md text-input"
                      v-model="tenth_aggregatepercentage"
                      required
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!--10th sslc details end  -->

      <!--12th hsc,diploma details start  -->
      <div class="mt-10 flex flex-col gap-5">
        <h1 class="text font-bold bg-primary text-center text-lg">
          12th / HSC / Diploma / ITI Details
        </h1>
        <div>
          <p class="text-sm text-[#4b5563] py-2 font-medium">
            Class 12 / Equivalent
          </p>
          <div class="overflow-x-auto">
            <table class="w-full text-black">
              <thead>
                <tr class="text-sm">
                  <th class="border table_border p-2 w-5"></th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="schoolname" class="text-sm input_label"
                      >School Name <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="board" class="text-sm input_label"
                      >Board <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="stream" class="text-sm input_label"
                      >Stream <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="yearofpass" class="text-sm input_label"
                      >Year of Passing <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="makingscheme" class="text-sm input_label"
                      >Making Scheme<span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[200px]">
                    <label for="aggregatepercentage" class="text-sm input_label"
                      >Aggregate Percentage/CGPA Obtained
                      <span class="span-color">*</span></label
                    >
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-sm">
                  <td class="border table_border p-1">
                    <p class="text-sm text-[#4b5563] font-normal text-center">
                      Class 12 / Equivalent
                    </p>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="text"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md text-input"
                      v-model="twelth_schoolname"
                      required
                    />
                  </td>
                  <td class="border table_border p-1">
                    <select
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      class="block w-full py-2 text-sm font-normal text-input rounded-md"
                      aria-label="Default select example"
                      required
                      v-model="twelth_board"
                    >
                      <option value="" selected disabled>Select</option>
                      <option
                        v-for="board in twelth_board_list"
                        :key="board.id"
                        :value="board.id"
                      >
                        {{ board.name }}
                      </option>
                    </select>
                  </td>
                  <td class="border table_border p-1">
                    <select
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      class="block w-full py-2 text-sm font-normal text-input rounded-md"
                      aria-label="Default select example"
                      required
                      v-model="twelth_stream"
                    >
                      <option value="" selected disabled>Select</option>
                      <option
                        v-for="stream in twelth_stream_list"
                        :key="stream.id"
                        :value="stream.id"
                      >
                        {{ stream.name }}
                      </option>
                    </select>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="date"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md text-input"
                      v-model="twelth_yearofpass"
                      required
                    />
                  </td>
                  <td class="border table_border p-1">
                    <select
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      class="block w-full py-2 text-sm font-normal rounded-md text-input"
                      aria-label="Default select example"
                      required
                      v-model="twelth_makingscheme"
                    >
                      <option value="" selected disabled>Select</option>
                      <option
                        v-for="schemes in twelth_scheme_list"
                        :key="schemes.id"
                        :value="schemes.id"
                      >
                        {{ schemes.name }}
                      </option>
                    </select>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="tel"
                      onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                      maxlength="2"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md text-input"
                      v-model="twelth_aggregatepercentage"
                      required
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--12th hsc,diploma details end  -->
      <!--graduation start  -->
      <div class="mt-10 flex flex-col gap-5">
        <h1 class="text font-bold bg-primary text-center text-lg">
          Graduation Details
        </h1>

        <div class="w-[300px] flex flex-col gap-3 py-3">
          <label for="resultstatus" class="text-sm input_label"
            >UG Result Status <span class="span-color">*</span></label
          >
          <select
            :class="{
              'cursor-not-allowed bg-disable': disableStatus === true,
              'cursor-pointer bg-primary2': disableStatus === false,
            }"
            :disabled="disableStatus"
            class="block w-full py-2 text-sm font-normal text-input rounded-md"
            aria-label="Default select example"
            required
            @change="collegeDetails"
            v-model="degree_resultstatus"
          >
            <option value="" selected disabled>Select</option>
            <option value="Declared">Declared</option>
            <option value="Not">Not Declared</option>
          </select>
        </div>

        <div v-if="college_status">
          <p class="text-sm text-[#4b5563] py-2 font-medium">
            Graduation Details
          </p>
          <div class="overflow-x-auto">
            <table class="w-full text-black">
              <thead>
                <tr class="text-sm">
                  <th class="border table_border p-2 w-5"></th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="collegename" class="text-sm input_label"
                      >Name of College <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="university" class="text-sm input_label"
                      >Name of University
                      <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="degree" class="text-sm input_label"
                      >Degree <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="yearofpass" class="text-sm input_label"
                      >Year of Passing <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[150px]">
                    <label for="makingscheme" class="text-sm input_label"
                      >Making Scheme<span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[200px]">
                    <label for="percentage" class="text-sm input_label">
                      Percentage/GPA Secured
                      <span class="span-color">*</span></label
                    >
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-sm">
                  <td class="border table_border p-1">
                    <p class="text-sm text-[#4b5563] font-normal text-center">
                      UG
                    </p>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="text"
                      class="w-full px-3 py-2 text-sm rounded-md font-normal text-input"
                      v-model="degree_collegename"
                      :required="college_status"
                    />
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="text"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md text-input"
                      v-model="degree_university"
                      :required="college_status"
                    />
                  </td>
                  <td class="border table_border p-1">
                    <select
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      class="block w-full py-2 text-sm font-normal text-input rounded-md"
                      aria-label="Default select example"
                      :required="college_status"
                      v-model="degree_degreename"
                    >
                      <option value="" selected disabled>Select</option>
                      <option
                        v-for="degreename in degreename_list"
                        :key="degreename.id"
                        :value="degreename.id"
                      >
                        {{ degreename.name }}
                      </option>
                    </select>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="date"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md text-input"
                      v-model="degree_yearofpass"
                      :required="college_status"
                    />
                  </td>
                  <td class="border table_border p-1">
                    <select
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      class="block w-full py-2 text-sm font-normal rounded-md text-input"
                      aria-label="Default select example"
                      :required="college_status"
                      v-model="degree_makingscheme"
                    >
                      <option value="" selected disabled>Select</option>
                      <option
                        v-for="schemes in degree_scheme_list"
                        :key="schemes.id"
                        :value="schemes.id"
                      >
                        {{ schemes.name }}
                      </option>
                    </select>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      :disabled="disableStatus"
                      type="text"
                      onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                      maxlength="2"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md text-input"
                      v-model="degree_percentage"
                      :required="college_status"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--graduation end  -->
      <!--work esperience start -->
      <div class="mt-10 flex flex-col gap-5">
        <h1 class="text font-bold bg-primary text-center text-lg">
          Work Experience
        </h1>
        <div class="flex flex-col lg:flex-row justify-between gap-5">
          <div class="w-[50%] flex flex-col gap-3 py-3">
            <label for="experience" class="text-sm input_label"
              >Do you have Work Experience
              <span class="span-color">*</span></label
            >
            <select
              :class="{
                'cursor-not-allowed bg-disable': disableStatus === true,
                'cursor-pointer bg-primary2': disableStatus === false,
              }"
              :disabled="disableStatus"
              class="block w-full py-2 text-sm font-normal text-input rounded-md"
              aria-label="Default select example"
              required
              v-model="work_experience_inner"
            >
              <option value="" selected disabled>Select</option>
              <option value="true" @click="workdetail = true">Yes</option>
              <option value="false" @click="workdetail = false">No</option>
            </select>
          </div>
        </div>

        <div v-if="workdetail == true">
          <p class="text-sm text-[#4b5563] py-2 font-medium">
            Work Experience Details
          </p>
          <div class="overflow-x-auto">
            <table class="w-full text-black">
              <thead>
                <tr class="text-sm">
                  <th class="border table_border p-2 w-[130px]">
                    <label for="employername" class="text-sm input_label"
                      >Employer Name <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[130px]">
                    <label for="industry" class="text-sm input_label"
                      >Industry <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[130px]">
                    <label for="designation" class="text-sm input_label"
                      >Designation <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[130px]">
                    <label for="startdate" class="text-sm input_label"
                      >Start date <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[130px]">
                    <label for="enddate" class="text-sm input_label"
                      >End date<span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[130px]">
                    <label for="tenure" class="text-sm input_label">
                      Tenure (in months)
                      <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[130px]">
                    <label for="tenure" class="text-sm input_label">
                      Occupation
                      <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2 w-[100px]">
                    <label
                      for="tenure"
                      class="text-sm input_label flex justify-end"
                    >
                      Total Experience
                      <span class="span-color">*</span></label
                    >
                  </th>
                  <th class="border table_border p-2">
                    <label
                      for="tenure"
                      class="text-sm input_label flex justify-end"
                    >
                      Action
                    </label>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(exp, index) in workExperience"
                  :key="index"
                  class="text-xs"
                >
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      type="text"
                      class="w-full px-3 py-2 text-sm table_border rounded-md font-normal text-input"
                      v-model="exp.employee_name"
                      :required="workdetail"
                      :disabled="disableStatus"
                    />
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      type="text"
                      class="w-full px-3 py-2 text-sm table_border rounded-md font-normal text-input"
                      v-model="exp.industry"
                      :required="workdetail"
                      :disabled="disableStatus"
                    />
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :disabled="disableStatus"
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      type="text"
                      class="w-full px-3 py-2 text-sm table_border rounded-md font-normal text-input"
                      v-model="exp.designation"
                      :required="workdetail"
                    />
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :disabled="disableStatus"
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      type="date"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md table_border text-input"
                      v-model="exp.start_date"
                      :required="workdetail"
                    />
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :disabled="disableStatus"
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      type="date"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md table_border text-input"
                      v-model="exp.end_date"
                      :required="workdetail"
                    />
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :disabled="disableStatus"
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      type="number"
                      class="w-full px-3 py-2 text-sm font-normal rounded-md table_border text-input"
                      v-model="exp.tenure"
                      :required="workdetail"
                    />
                  </td>
                  <td class="border table_border p-1">
                    <select
                      :disabled="disableStatus"
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      class="block w-full py-2 text-sm font-normal text-input rounded-md table_border"
                      aria-label="Default select example"
                      required
                      v-model="exp.occupation"
                    >
                      <option value="" selected disabled>Select</option>
                      <option value="Full-Time">Full Time</option>
                      <option value="Part-Time">Part Time</option>
                    </select>
                  </td>
                  <td class="border table_border p-1">
                    <input
                      :disabled="disableStatus"
                      type="tel"
                      maxlength="2"
                      onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus === true,
                        'cursor-pointer bg-primary2': disableStatus === false,
                      }"
                      class="w-full px-3 py-2 text-sm font-normal text-center text-input rounded-md table_border"
                      v-model="exp.total_work_experience"
                      placeholder="Enter Total Work Experience"
                      required
                    />
                  </td>
                  <td class="border table_border p-1">
                    <button
                      @click="closeRow(index)"
                      :disabled="disableStatus"
                      :class="{
                        'cursor-not-allowed bg-disable': disableStatus,
                        'cursor-pointer bg-primary2': !disableStatus,
                      }"
                      class="border span-color p-1 rounded-md w-[20px] mx-auto table_border text-center flex justify-center"
                    >
                      X
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="flex justify-end py-4">
            <button
              @click="addExperience"
              :disabled="disableStatus"
              :class="{
                'cursor-not-allowed bg-disable  text-input': disableStatus,
                'cursor-pointer  bg-primary text': !disableStatus,
              }"
              class="font-bold rounded-md p-1 text-sm flex gap-1 items-center"
            >
              <span class="bg-white rounded-full text-[#1e3a8a]">
                <img
                  :src="plus"
                  class="bg-white w-3 h-3 rounded-full"
                  alt="Plus icon"
                />
              </span>
              MORE
            </button>
          </div>
        </div>
      </div>
      <!--work esperience end -->

      <div v-if="submit_button == false" class="flex justify-between w-full">
        <div class="text-success text-xl">
          <p v-if="message">{{ message }}</p>
          <p v-if="error_message">{{ error_message }}</p>
        </div>
        <div class="flex justify-end items-center">
          <button
            :disabled="disableStatus"
            :class="{
              'cursor-not-allowed bg-disable dark_text': disableStatus === true,
              'cursor-pointer btn': disableStatus === false,
            }"
            type="submit"
            class="px-5 py-1 text-[16px] rounded-md"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "EducationView",
  props: ["complete_status"],
  data() {
    return {
      plus: require(`${process.env.VUE_APP_PLUS}`),
      tenth_schoolname: "",
      tenth_board: "",
      tenth_yearofpass: "",
      tenth_makingscheme: "",
      tenth_aggregatepercentage: "",
      tenth_scheme_list: [],
      tenth_board_list: [],

      twelth_schoolname: "",
      twelth_board: "",
      twelth_stream: "",
      twelth_yearofpass: "",
      twelth_makingscheme: "",
      twelth_aggregatepercentage: "",
      twelth_scheme_list: [],
      twelth_stream_list: [],
      twelth_board_list: [],

      degree_resultstatus: "",
      degree_collegename: "",
      degree_university: "",
      degree_degreename: "",
      degree_yearofpass: "",
      degree_makingscheme: "",
      degree_percentage: "",
      degreename_list: [],
      degree_scheme_list: [],

      workExperience: [
        {
          occupation: "",
          work_experience: this.work_experience_inner,
          employee_name: "",
          industry: "",
          designation: "",
          start_date: "",
          end_date: "",
          tenure: "",
          total_work_experience: "",
        },
      ],
      message: "",
      submitAdditional: false,
      disableStatus: false,
      workdetail: true,
      work_experience_inner: "",
      submit_button: false,
      toggle_edit: false,
      error_message: "",
      college_status: true,
      loader: true,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  async created() {
    await this.getTenthBoard();
    await this.getTenthScheme();
    await this.getTwelthBoard();
    await this.getTwelthScheme();
    await this.getTwelthStream();
    await this.getDegreeName();
    await this.getDegreeScheme();
    await this.getEducateDetails();
  },
  methods: {
    closeRow(index) {
      this.workExperience.splice(index, 1);
    },
    // 10th
    async getTenthBoard() {
      await axios
        .get(`${process.env.VUE_APP_API}/board-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.tenth_board_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async getTenthScheme() {
      await axios
        .get(`${process.env.VUE_APP_API}/marketingscheme-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.tenth_scheme_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    collegeDetails() {
      if (this.degree_resultstatus === "Declared") {
        this.college_status = true;
        if (this.workdetail === true) {
          this.workdetail = true;
          this.work_experience_inner = "";
        }
        // this.workdetail = true;
        // this.work_experience_inner = "";
      } else {
        this.college_status = false;
        this.workdetail = false;
        this.work_experience_inner = false;
      }
    },

    // 12th
    async getTwelthBoard() {
      await axios
        .get(`${process.env.VUE_APP_API}/board-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.twelth_board_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async getTwelthScheme() {
      await axios
        .get(`${process.env.VUE_APP_API}/marketingscheme-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.twelth_scheme_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async getTwelthStream() {
      await axios
        .get(`${process.env.VUE_APP_API}/stream-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.twelth_stream_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    // ug Degree
    async getDegreeName() {
      await axios
        .get(`${process.env.VUE_APP_API}/degree-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.degreename_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async getDegreeScheme() {
      await axios
        .get(`${process.env.VUE_APP_API}/marketingscheme-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.degree_scheme_list = resp.data.data;
            this.loader = false;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    // work experience
    addExperience() {
      this.workExperience.push({
        occupation: "",
        employee_name: "",
        work_experience: this.work_experience_inner,
        industry: "",
        designation: "",
        start_date: "",
        end_date: "",
        tenure: "",
        total_work_experience: "",
      });
    },

    submitEducation() {
      let educationData = {};
      if (this.workdetail == false || this.college_status == false) {
        educationData = {
          school_name_secondary: this.tenth_schoolname,
          board_secondary: this.tenth_board,
          year_of_passing_secondary: this.tenth_yearofpass,
          marketing_scheme_secondary: this.tenth_makingscheme,
          cgpa_secondary: this.tenth_aggregatepercentage,

          school_name_higher: this.twelth_schoolname,
          board_higher: this.twelth_board,
          stream: this.twelth_stream,
          year_of_passing_higher: this.twelth_yearofpass,
          marketing_scheme_higher: this.twelth_makingscheme,
          cgpa_higher: this.twelth_aggregatepercentage,

          // ug_result_status: this.degree_resultstatus,
          // name_of_college: this.degree_collegename,
          // name_of_university: this.degree_university,
          // degree: this.degree_degreename,
          // year_of_passing_ug: this.degree_yearofpass,
          // marketing_scheme_ug: this.degree_makingscheme,
          // gpa: this.degree_percentage,
          work_experience: [],
        };
      } else {
        educationData = {
          school_name_secondary: this.tenth_schoolname,
          board_secondary: this.tenth_board,
          year_of_passing_secondary: this.tenth_yearofpass,
          marketing_scheme_secondary: this.tenth_makingscheme,
          cgpa_secondary: this.tenth_aggregatepercentage,

          school_name_higher: this.twelth_schoolname,
          board_higher: this.twelth_board,
          stream: this.twelth_stream,
          year_of_passing_higher: this.twelth_yearofpass,
          marketing_scheme_higher: this.twelth_makingscheme,
          cgpa_higher: this.twelth_aggregatepercentage,

          ug_result_status: this.degree_resultstatus,
          name_of_college: this.degree_collegename,
          name_of_university: this.degree_university,
          degree: this.degree_degreename,
          year_of_passing_ug: this.degree_yearofpass,
          marketing_scheme_ug: this.degree_makingscheme,
          gpa: this.degree_percentage,
          work_experience: this.workExperience,
        };
      }

      if (this.toggle_edit == false) {
        axios
          .post(
            `${process.env.VUE_APP_API}/education-and-workexperience/?Key=${this.userInfo.data.token}`,
            educationData
          )
          .then((resp) => {
            if (resp.data.status == 200) {
              this.message = resp.data.message;
              this.$emit("formCompleted");
              this.disableStatus = true;
              this.submitAdditional = true;
              this.getEducateDetails();
              setTimeout(() => {
                this.message = "";
              }, 3000);
            } else if (resp.data.status == 400) {
              this.error_message = resp.data.message;
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      } else {
        console.log("patchdata.....");
        axios
          .patch(
            `${process.env.VUE_APP_API}/education-and-workexperienceretrieveupdatedelet/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
            educationData
          )
          .then((resp) => {
            console.log("patchdata123.....");
            if (resp.data.status == 200) {
              this.message = resp.data.message;

              setTimeout(() => {
                this.message = "";
              }, 3000);
              this.toggle_edit = false;

              this.disableStatus = true;
              // this.submitAdditional = true;
              this.getEducateDetails();
            } else if (resp.data.status == 400) {
              this.error_message = resp.data.message;
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    },

    async getEducateDetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/education-and-workexperienceretrieveupdatedelet/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.status === 200) {
            const details = resp.data;
            this.loader = false;
            this.toggle_edit = false;
            if (details) {
              this.tenth_schoolname = details.secondary_school.school_name;
              this.tenth_board = details.secondary_school.board;
              this.tenth_yearofpass = details.secondary_school.year_of_passing;
              this.tenth_makingscheme =
                details.secondary_school.marketing_scheme;
              this.tenth_aggregatepercentage = details.secondary_school.cgpa;

              this.twelth_schoolname =
                details.higher_secondary_school.school_name;
              this.twelth_board = details.higher_secondary_school.board;
              this.twelth_stream = details.higher_secondary_school.stream;
              this.twelth_yearofpass =
                details.higher_secondary_school.year_of_passing;
              this.twelth_makingscheme =
                details.higher_secondary_school.marketing_scheme;
              this.twelth_aggregatepercentage =
                details.higher_secondary_school.cgpa;
              if (details.undergraduate != null) {
                this.degree_resultstatus =
                  details.undergraduate.ug_result_status;
                this.degree_collegename = details.undergraduate.name_of_college;
                this.degree_university =
                  details.undergraduate.name_of_university;
                this.degree_degreename = details.undergraduate.degree;
                this.degree_yearofpass = details.undergraduate.year_of_passing;
                this.degree_makingscheme =
                  details.undergraduate.marketing_scheme;
                this.degree_percentage = details.undergraduate.gpa;
              } else {
                this.degree_resultstatus = "Not";
                this.college_status = false;
              }

              this.workExperience = details.work_experience;
              if (details.work_experience.length > 0) {
                this.work_experience_inner = true;
              } else {
                this.work_experience_inner = false;
                this.workdetail = false;
              }
              // if (details.is_form_completed && details.is_form_five_filled) {
              //   this.submitAdditional = false;
              //   this.toggle_edit = false;
              //   this.disableStatus = true;
              //   this.submit_button = true;
              // } else if (
              //   details.is_form_completed != true &&
              //   details.is_form_five_filled == true
              // ) {
              //   this.toggle_edit = false;

              //   this.submitAdditional = true;
              //   this.disableStatus = true;
              // } else {
              //   this.submitAdditional = false;
              //   this.disableStatus = false;
              // }
              if (details.is_form_five_filled == true) {
                this.submitAdditional = true;
                this.disableStatus = true;
                this.toggle_edit = false;
              }
            }
          } else {
            this.loader = false;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    toggleEdit() {
      this.disableStatus = false;
      this.submitAdditional = false;
      this.toggle_edit = true;
    },
  },
};
</script>

<style></style>
